// How the fragment shader should treat a vertex. Carried per-vertex so a single
// draw call can mix filled geometry, analytic circles, text and images.

// Flat colour from the vertex colour.
export const MODE_SOLID = 0;

// Analytic disc or ring. UV runs -1..1 across the quad; the parameter is the
// inner radius as a fraction of the outer, so 0 is a filled disc.
export const MODE_CIRCLE = 1;

// Signed distance field glyph sampled from the atlas alpha, tinted by the vertex
// colour.
export const MODE_GLYPH = 2;

// Colour bitmap sampled from the atlas, modulated by the vertex colour's alpha.
export const MODE_IMAGE = 3;

// A connection line carrying traffic. UV.x runs 0..1 from the child end to the
// parent end, and the parameter is how busy the link is; the shader rides pulses
// along it and dims the line between them.
export const MODE_PULSE = 4;

// One particle of fire or smoke. UV is the corner of its quad; the parameter
// packs a per-particle seed into the whole part and its phase in the emitter's
// cycle into the fraction, which is what lets the whole plume animate from a
// clock with no per-frame work at all.
export const MODE_PARTICLE = 6;

// How long a particle takes to cross its emitter, and the range the packed seed
// occupies. Shared with the shader, which cannot import them.
export const PARTICLE_LIFE_SECONDS = 2.4;
export const PARTICLE_SEED_RANGE = 255;
